import { useSyncExternalStore } from 'react';

/**
 * Subscribe to a CSS media query and re-render when it flips.
 *
 * Built on useSyncExternalStore so the value is read directly from
 * matchMedia on every render — no initial-state flash and no listener
 * leaks across remounts.
 *
 * @param {string} query - A media query, e.g. '(max-width: 767px)'.
 * @returns {boolean} Whether the query currently matches.
 */
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    },
    () => window.matchMedia(query).matches,
  );
}

/**
 * Whether the viewport is below Tailwind's `md` breakpoint (768px).
 *
 * The app's mobile/desktop boundary: JS conditional mounts (e.g. the
 * comparison card list vs the virtualised table) must agree with any
 * `md:` utility classes, so both derive from the same 768px line.
 *
 * @returns {boolean} True on phone-sized viewports.
 */
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}
